import * as React from 'react';

export function Retry () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="25"
      fill="none"
      viewBox="0 0 22 25"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1 13.75c0 5.385 4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S16.135 4 10.75 4h-3m0 0 3-3m-3 3 3 3"
      />
    </svg>
  );
}
